module.exports = __webpack_public_path__ + "static/media/branding_01_B.662e728c.png";